import StoryBody01 from './StoryBody01';
import StoryBody02 from './StoryBody02';
import StoryBody03 from './StoryBody03';
import StoryBody04 from './StoryBody04';
import StoryBody05 from './StoryBody05';
import StoryBody06 from './StoryBody06';

const StoryMappings = {
  ContentfulStoryBody01FullText: StoryBody01,
  ContentfulStoryBody02FullImage: StoryBody02,
  ContentfulStoryBody03TextImage: {
    'Text:Image, Side by Side, 1:1': StoryBody04,
    'Text:Image, Side by Side, 1:2': StoryBody03,
    'Text:Image, Stacked, 1:2': StoryBody05,
    'Text:Small Image': StoryBody06,
  },
};

export default StoryMappings;
